export const GET_LIST_OF_TRAINING_FORM =
  'src/modules/trainingsAnylasis/GET_LIST_OF_TRAINING_FORM';
export const ADD_TRAINING =
  'src/modules/trainingsAnylasis/ADD_TRAINING';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/trainingsAnylasis/CANCEL_ALL_API_REQUESTS';


